import React from 'react';
import PropTypes from 'prop-types';

const BotAvatarIcon = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="AI assistant avatar"
  >
    <rect x="5" y="7" width="14" height="12" rx="4" stroke="currentColor" strokeWidth="1.8" />
    <path d="M12 3V7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="9.5" cy="12.5" r="1.2" fill="currentColor" />
    <circle cx="14.5" cy="12.5" r="1.2" fill="currentColor" />
    <path d="M9 16H15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

BotAvatarIcon.propTypes = {
  className: PropTypes.string
};

BotAvatarIcon.defaultProps = {
  className: ''
};

export default BotAvatarIcon;
